import { environment } from '../../../environments/environment';

export const SEO_DEFAULTS = {
  siteName: 'Perrón Store',
  siteUrl: environment.siteUrl,
  defaultTitle: 'Perrón Store — Trading Card Games en Costa Rica',
  defaultDescription:
    'Tienda especializada en TCG (Magic, Pokémon, Yu-Gi-Oh!, One Piece y más) en Costa Rica. Compra cartas sueltas, sobres, productos sellados y reserva precompras.',
  defaultImage: '/images/og/og-default.jpg',
  locale: 'es_CR',
  twitterCard: 'summary_large_image' as const,
  themeColor: '#385898',
  social: {
    instagram: 'https://instagram.com/perronstore',
    facebook: 'https://facebook.com/perronstore',
  },
} as const;

export const SEO_TITLE_SUFFIX = ' — Perrón Store';

export const SEO_NOINDEX_PATHS: readonly string[] = [
  '/checkout',
  '/comparar',
  '/reset-password',
  '/verificar-cuenta',
  '/avisarme/unsubscribe',
] as const;
